export default __webpack_public_path__ + "static/media/desktop-etapa4.453da7ca.jpg";